import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store.js'
import '@/firebase/'

import { mapState } from 'vuex'
import { mapActions } from 'vuex'

import hu from '@/resources/lang/global-hu'
import en from '@/resources/lang/global-en'
import constants from '@/resources/constants'

import CustomTag from './components/ui/CustomTag'
Vue.component('CustomTag', CustomTag)

import Icon from './components/ui/Icon'
Vue.component('Icon', Icon)

import Logo from './components/ui/Logo'
Vue.component('Logo', Logo)

import Button from './components/ui/Button'
Vue.component('Button', Button)

import TextField from './components/ui/TextField'
Vue.component('TextField', TextField)

import TextFieldError from './components/ui/TextFieldError'
Vue.component('TextFieldError', TextFieldError)

import RadioButton from './components/ui/RadioButton'
Vue.component('RadioButton', RadioButton)

import CheckBox from './components/ui/CheckBox'
Vue.component('CheckBox', CheckBox)

import DatePicker from './components/ui/DatePicker'
Vue.component('DatePicker', DatePicker)

import LoadingOverlay from './components/ui/LoadingOverlay'
Vue.component('LoadingOverlay', LoadingOverlay)

import Loader from './components/ui/Loader'
Vue.component('Loader', Loader)

import Feedback from './components/ui/Feedback'
Vue.component('Feedback', Feedback)

import Modal from './components/ui/Modal'
Vue.component('Modal', Modal)

import Dialog from './components/ui/Dialog'
Vue.component('Dialog', Dialog)

import TransitionEffect from './components/ui/TransitionEffect'
Vue.component('TransitionEffect', TransitionEffect)

import Heading from './components/ui/Heading'
Vue.component('Heading', Heading)

import Toggle from './components/ui/Toggle'
Vue.component('Toggle', Toggle)

import Dropdown from './components/ui/Dropdown'
Vue.component('Dropdown', Dropdown)

import Badge from './components/ui/Badge'
Vue.component('Badge', Badge)

import FetchError from './components/templates/FetchError'
Vue.component('FetchError', FetchError)

import BlurCapImage from './components/templates/blurCapImage/BlurCapImage'
Vue.component('BlurCapImage', BlurCapImage)

import BlurredBackground from './components/ui/BlurredBackground'
Vue.component('BlurredBackground', BlurredBackground)

import VScrollLock from 'v-scroll-lock'
Vue.use(VScrollLock)

import checkView from 'vue-check-view'
Vue.use(checkView)

import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

import VueBlurHash from 'vue-blurhash'
Vue.use(VueBlurHash)

import Toasted from 'vue-toasted'
let options = {
    theme: 'toasted-primary',
    position: 'bottom-center',
    duration: 5000,
    action : {
        text : 'close',
        onClick : (e, toastObject) => {
            toastObject.goAway(0)
        }
    },
}
Vue.use(Toasted, options)

var VueAutosize = require('vue-autosize')
Vue.use(VueAutosize)

var VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo, { offset: -64, container: 'body' })

Vue.mixin({
    computed: {
        ...mapState('users',['preferences','hasAcceptedCookies','loggedInUser']),
        ...mapState('authentication', ['auth']),

        siteContent() {
            if(this.preferences.language === 'en') {
                return en
            } else if(this.preferences.language === 'hu') {
                return hu
            }
        },
        constants() {
            return constants
        },
        permissions() {
            let permissions = {
                isAdmin: this.auth.roles.includes('admin'),
                isArtist: this.auth.roles.includes('artist'),
                isWriter: this.auth.roles.includes('writer'),
                isTester: this.auth.roles.includes('test'),
            }

            return permissions
        }
    },
    mounted() {
        if(this.auth.id) {
            this.fetchLoggedInUser(this.auth.id)
        }
        
        if(this.preferences.language === 'hu') {
            moment.locale('hu')
        } else {
            moment.locale('en')
        }
    },
    methods: {
        ...mapActions('users',['fetchLoggedInUser']),

        getContent(content) {
            if(this.preferences.language === 'hu') {
                return content.hu
            } else {
                return content.en
            }
        }
    },
    watch: {
        auth() {
            if(this.auth.id) {
                this.fetchLoggedInUser(this.auth.id)
            }
        }
    }
})

const moment = require('moment')
Vue.use(require('vue-moment'), {
    moment
})

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')